import "core-js/modules/esnext.promise.all-settled.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
function getFinishFromUrl(finishId, finishUrl) {
  return __awaiter(this, void 0, void 0, function* () {
    var _a;
    const response = yield fetch(finishUrl);
    if (!response.ok) {
      if ((_a = response.headers.get("content-type")) === null || _a === void 0 ? void 0 : _a.includes("application/json")) {
        const data = yield response.json();
        throw new Error("Failed to fetch finish '".concat(finishId, "' from '").concat(finishUrl, "': ").concat(JSON.stringify(data), "}"));
      }
      throw new Error("Failed to fetch finish '".concat(finishId, "' from '").concat(finishUrl, "'!"));
    }
    const finishData = yield response.json();
    return finishData;
  });
}
function getSubstrateFromUrl(substrateId, substrateUrl) {
  return __awaiter(this, void 0, void 0, function* () {
    var _a;
    const response = yield fetch(substrateUrl);
    if (!response.ok) {
      if ((_a = response.headers.get("content-type")) === null || _a === void 0 ? void 0 : _a.includes("application/json")) {
        const data = yield response.json();
        throw new Error("Failed to fetch substrate '".concat(substrateId, "' from '").concat(substrateUrl, "': ").concat(JSON.stringify(data), "}"));
      }
      throw new Error("Failed to fetch substrate '".concat(substrateId, "' from '").concat(substrateUrl, "'!"));
    }
    const substrateData = yield response.json();
    return substrateData;
  });
}
export function loadSubstrateMap(config) {
  return __awaiter(this, void 0, void 0, function* () {
    const substrates = {};
    const promises = Object.keys(config.substrateUrlMap).map(substrateKey => getSubstrateFromUrl(substrateKey, config.substrateUrlMap[substrateKey]).then(substrate => {
      substrates[substrateKey] = substrate;
    }));
    yield Promise.allSettled(promises);
    return substrates;
  });
}
export function loadFinishMap(config) {
  return __awaiter(this, void 0, void 0, function* () {
    const finishes = {};
    if (!config.finishUrlMap) {
      return finishes;
    }
    const promises = Object.keys(config.finishUrlMap).map(finishKey => __awaiter(this, void 0, void 0, function* () {
      if (!config.finishUrlMap) return;
      finishes[finishKey] = yield getFinishFromUrl(finishKey, config.finishUrlMap[finishKey]);
    }));
    yield Promise.allSettled(promises);
    return finishes;
  });
}